import React, { useState, useEffect, useRef } from "react";

const RecaptchaComponent = (props) => {
    const { setPassedRecaptchaV2, v2SiteKey } = props;
    const recaptchaRef = useRef(null);

    useEffect(() => {
        //const v2SiteKey = "6LeIYqUrAAAAAGoi1EgqwEVjXTD-5gDohOpr3SDT";

        // Initialize reCAPTCHA
        window.grecaptcha.ready(() => {
            window.grecaptcha.render(recaptchaRef.current, {
                'sitekey': v2SiteKey,
                'callback': handleRecaptchaCallback,
                'expired-callback': handleRecaptchaExpiredCallback
            });
        });
    }, []);

    const handleRecaptchaCallback = (response) => {
        // console.log('reCAPTCHA callback response:', response);
        setPassedRecaptchaV2(true);
    };

    const handleRecaptchaExpiredCallback = (response) => {
        setPassedRecaptchaV2(false);
    }

    return (
        <div>
            <div
                ref={recaptchaRef}
                data-sitekey={v2SiteKey}
                data-callback={handleRecaptchaCallback}
                data-expired-callback={handleRecaptchaExpiredCallback}
            ></div>
        </div>
    );
};

export default RecaptchaComponent;
